import { render, staticRenderFns } from "./setMeal.vue?vue&type=template&id=24a338e1&scoped=true"
import script from "./setMeal.vue?vue&type=script&lang=js"
export * from "./setMeal.vue?vue&type=script&lang=js"
import style0 from "./setMeal.vue?vue&type=style&index=0&id=24a338e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a338e1",
  null
  
)

export default component.exports